import React, { ChangeEvent } from "react";

import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import { ReactComponent as CopyIcon } from "src/images/duplicate-gray.svg";
import { ReactComponent as EditIcon } from "src/images/edit-gray.svg";
import { ReactComponent as GridIcon } from "src/images/grid.svg";
import { ReactComponent as LightningIcon } from "src/images/lightning.svg";
import { ReactComponent as TrashCanIcon } from "src/images/trash-can-gray.svg";
import { Template } from "./types";
import useSortableItem from "src/app/components/VerticalDragAndDropList/useSortableItem";

interface DraggableTemplateItemProps {
  template: Template;
  handleEnableTemplate: (
    e: ChangeEvent<HTMLInputElement>,
    template: Template,
  ) => void;
  setEditedTemplate: (template: Template) => void;
  handleDuplicateTemplate: (template: Template) => void;
  setTemplateToRemove: (template: Template) => void;
}

export default function DraggableTemplateItem({
  template,
  handleEnableTemplate,
  setEditedTemplate,
  handleDuplicateTemplate,
  setTemplateToRemove,
}: DraggableTemplateItemProps) {
  const { attributes, listeners, setNodeRef, style } = useSortableItem(
    template.uuid,
  );

  return (
    <li
      ref={setNodeRef}
      style={style}
      className="template-manager__list-item grid--templates-list"
      data-qa-field-name={template.name}
    >
      <div className="template-manager__text">
        <div className="icon-drag" {...attributes} {...listeners}>
          <GridIcon />
        </div>

        <div className="template-manager__list-col">
          <div className="template-manager__name">
            <span className="template-manager__name-text">{template.name}</span>
          </div>
          <div className="template-manager__description">
            {template.description}
          </div>
        </div>
      </div>
      <CustomSwitch
        checked={template.enabled}
        onChange={(e) => handleEnableTemplate(e, template)}
      />
      <div className="template-manager__list-actions">
        <div className="template-manager__extensions-count">
          <LightningIcon />
          {template.extensions.length + template.automations.length}
        </div>
        <button
          className="button-style-reset"
          type="button"
          aria-label="Edit template"
          onClick={() => setEditedTemplate(template)}
        >
          <EditIcon />
        </button>
        <button
          aria-label="Duplicate template"
          type="button"
          className="button-style-reset"
          onClick={() => handleDuplicateTemplate(template)}
        >
          <CopyIcon />
        </button>
        <button
          aria-label="Remove template"
          type="button"
          className="button-style-reset"
          onClick={() => setTemplateToRemove(template)}
        >
          <TrashCanIcon />
        </button>
      </div>
    </li>
  );
}
